import axiosInstance from "@/api/axiosInstance";
import { ExportEventAttendanceCsvRequest } from "./types";

export const exportEventAttendanceCsv = async (
  requestData: ExportEventAttendanceCsvRequest,
): Promise<Blob> => {
  const url = `/api/private/event-sessions/${requestData.uuid}/attendances/csv`;

  const response = await axiosInstance.get<Blob>(url, {
    responseType: "blob",
    headers: {
      Accept: "text/csv",
    },
  });

  return response.data;
};
